import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { createMealType, editMealType } from 'features/food/foodSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const MealTypeModal = ({ closeModal, value }: { closeModal: any, value?: IMealTypeModal }) => {
    const [type, setType] = useState(value?.type || '')
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const resp = await dispatch(value?.id ? editMealType({ type, id: value.id }) : createMealType({ name: type }))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    return <Modal black>
        <Flex column between center height='30vh'>
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Meal Type</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='Breakfast, snack, lunch...' labelText='Meal type name' value={type} onChange={e => setType(e.target.value)} nomarg />
            </Flex>
            <Button disabled={!type} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface IMealTypeModal {
    id?: number
    type: string
}